import PagesController from 'controllers/PagesController';
import ComponentsManager from "controllers/ComponentsManager";
import Error404 from './Error404';
import Error404Header from "./Error404Header";


export default new class {
	constructor() {
		PagesController.addPage('error_404', Error404);
		ComponentsManager.register('error_404_header', Error404Header);
	}
};
